import { TextContent } from "./text-content";

export class DialogBox extends Phaser.GameObjects.Container {
    private _content: TextContent;

    constructor(x: number, y: number, content: string, scene: Phaser.Scene) {
        super(scene, x, y);
        this._content = new TextContent(x, y, content, scene);
        this.add(this._content);
    }

    public setText(newContent: string) {
        this._content.setText(newContent);
    }
}
